<template>
  <v-layout align-center justify-center>
    <v-flex xs12 offset-xs0 sm10 offset-sm1 md10 offset-md1
    lg10 offset-lg1 xl8 offset-xl2 class="mb-3 mx-0" align-center>
      <slot></slot>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'mv-default-row'
}
</script>
